// Angular
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * A custom validator to check if the autocomplete has a selected option.
 */
export function AutocompleteValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    

    // If the control value is set and is a string, it's invalid
    if (!!control.value && typeof control.value === 'string') {
      return { autocompleteRequired: true };
    }

    // Must be an FsxOption<string> so is valid or not set
    return null;
  };
}